"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLeafFont = exports.isLeafFontActive = exports.setBlockFont = exports.isBlockFontActive = exports.fontFamilyOf = exports.isFontKind = exports.FONT_FAMILIES = void 0;
const slate_1 = require("slate");
const lists_1 = require("./lists");
exports.FONT_FAMILIES = {
    sans: '"Inter Variable","Inter",-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif',
    serif: '"Source Serif 4 Variable","Source Serif 4","Source Serif Pro",Georgia,Cambria,"Times New Roman",Times,serif',
    slab: '"Bitter Variable","Bitter","Roboto Slab",Georgia,Cambria,"Times New Roman",Times,serif',
    mono: '"JetBrains Mono Variable","JetBrains Mono",Menlo,Consolas,"Liberation Mono",Courier,monospace',
};
const isFontKind = (v) => v === 'sans' || v === 'serif' || v === 'slab' || v === 'mono';
exports.isFontKind = isFontKind;
const fontFamilyOf = (kind) => kind ? exports.FONT_FAMILIES[kind] : undefined;
exports.fontFamilyOf = fontFamilyOf;
const isElement = (node) => slate_1.Element.isElement(node);
const isFormattableBlock = (node) => !(0, lists_1.isListType)(node.type) && node.type !== 'embed';
const getActiveBlockFont = (editor) => {
    const { selection } = editor;
    if (!selection)
        return undefined;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
    });
    if (!match)
        return undefined;
    const [element] = match;
    const value = element.font;
    return (0, exports.isFontKind)(value) ? value : undefined;
};
const isBlockFontActive = (editor, font) => getActiveBlockFont(editor) === font;
exports.isBlockFontActive = isBlockFontActive;
const setBlockFont = (editor, font) => {
    const current = getActiveBlockFont(editor);
    if (!font || current === font) {
        slate_1.Transforms.unsetNodes(editor, 'font', {
            match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
        });
        return;
    }
    slate_1.Transforms.setNodes(editor, { font }, {
        match: (node) => isElement(node) && slate_1.Editor.isBlock(editor, node) && isFormattableBlock(node),
    });
};
exports.setBlockFont = setBlockFont;
const getActiveLeafFont = (editor) => {
    const marks = slate_1.Editor.marks(editor);
    const value = marks?.font;
    return (0, exports.isFontKind)(value) ? value : undefined;
};
const isLeafFontActive = (editor, font) => getActiveLeafFont(editor) === font;
exports.isLeafFontActive = isLeafFontActive;
const setLeafFont = (editor, font) => {
    const current = getActiveLeafFont(editor);
    if (!font || current === font) {
        slate_1.Editor.removeMark(editor, 'font');
        return;
    }
    slate_1.Editor.addMark(editor, 'font', font);
};
exports.setLeafFont = setLeafFont;
